export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': 'a4cfe57d16mshf6979bde7aafc5cp1bd04bjsn5c4602ae7b71',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";


export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "e1b5bb3b831caf665791df0015530f8d";
